import { api } from '@/lib/api/client';

/** One xotski's standing in a project's pool. Mirrors `ProjectPoolRow`. */
export interface ProjectPoolRow {
  stockId: number;
  stockName: string;
  /**
   * True when the project committed this stock and `remaining` caps its
   * stations. False when the stations hold it without a commitment: the row
   * exists so `allocated` (the floor of any commitment) is known, but the
   * project stays uncapped for it and the brand headroom rules.
   */
  adopted: boolean;
  /** Units committed from the brand catalogue to this project. 0 when not adopted. */
  committed: number;
  /** Already handed to this project's stations. */
  allocated: number;
  /** committed − allocated, floored at 0. */
  remaining: number;
}

/**
 * The project rung of the inventory cascade (task 7.2):
 * brand catalogue → project pool → station allocation.
 *
 * An empty list means the project has not adopted the pool and is uncapped —
 * the warehouse lane falls back to brand headroom, which is how it always
 * behaved.
 */
export const projectStockPoolApi = {
  list: (eventGroupId: number) =>
    api.get<ProjectPoolRow[]>(`/xk-project-stock-pool/${eventGroupId}`),
  commit: (eventGroupId: number, stockId: number, quantity: number) =>
    api.post(`/xk-project-stock-pool/${eventGroupId}`, { stockId, quantity }),
};
